// Chapter-wise Python Topics for TutorLayout
const pytopics = [

  /* ---------- Chapter 1: Introduction ---------- */
  { category: "Chapter 1", title: "Type A", file: "/pages/PYTHON/ch-1/CH-1_Type-a.html" },
  { category: "Chapter 1", title: "Type B", file: "/pages/PYTHON/ch-1/CH-1_Type-b.html" },
  { category: "Chapter 1", title: "Type C", file: "/pages/PYTHON/ch-1/CH-1_Type-c.html" },

  /* ---------- Chapter 2: Basic Syntax ---------- */
  { category: "Chapter 2", title: "Type A", file: "/pages/PYTHON/ch-2/CH-2_Type-a.html" },
  { category: "Chapter 2", title: "Type B", file: "/pages/PYTHON/ch-2/CH-2_Type-b.html" },
  { category: "Chapter 2", title: "Type C", file: "/pages/PYTHON/ch-2/CH-2_Type-c.html" },

  /* ---------- Chapter 3: Operators ---------- */
  { category: "Chapter 3", title: "Type A", file: "/pages/PYTHON/ch-3/CH-3_Type-a.html" },
  { category: "Chapter 3", title: "Type B", file: "/pages/PYTHON/ch-3/CH-3_Type-b.html" },
  { category: "Chapter 3", title: "Type C", file: "/pages/PYTHON/ch-3/CH-3_Type-c.html" },


  /* ---------- Chapter 4: Conditional Statements ---------- */
  { category: "Chapter 4", title: "Type A", file: "/pages/PYTHON/ch-4/CH-4_Type-a.html" },
  { category: "Chapter 4", title: "Type B", file: "/pages/PYTHON/ch-4/CH-4_Type-b.html" },
  { category: "Chapter 4", title: "Type C", file: "/pages/PYTHON/ch-4/CH-4_Type-c.html" },

  /* ---------- Chapter 5: Loops ---------- */
  { category: "Chapter 5", title: "Type A", file: "/pages/PYTHON/ch-5/CH-5_Type-a.html" },
  { category: "Chapter 5", title: "Type B", file: "/pages/PYTHON/ch-5/CH-5_Type-b.html" },
  { category: "Chapter 5", title: "Type C", file: "/pages/PYTHON/ch-5/CH-5_Type-c.html" },


  /* ---------- Chapter 7: Stack ---------- */
  { category: "Chapter 7", title: "Summary", file: "/pages/PYTHON/ch-7/ch_7_summary.html" },
  { category: "Chapter 7", title: "Long Summary", file: "/pages/PYTHON/ch-7/ch_7_long_summary.html" },
  { category: "Chapter 7", title: "Practical 7.1", file: "/pages/PYTHON/ch-7/CH-7_page_288_practical.html" },
  { category: "Chapter 7", title: "Practical 7.1 code", file: "/pages/PYTHON/ch-7/Ch-7_page_299_7.1_.html" },
  { category: "Chapter 7", title: "Practical 7.1 debug", file: "/pages/PYTHON/ch-7/Ch-7_page_299_7.1_Practical.html" },
  { category: "Chapter 7", title: "Type A", file: "/pages/PYTHON/ch-7/CH-7_Type-a.html" },
  { category: "Chapter 7", title: "Type B", file: "/pages/PYTHON/ch-7/CH-7_Type-b.html" },

  /* ---------- Chapter 10: Relational Databases ---------- */
  { category: "Chapter 10", title: "Summary", file: "/pages/PYTHON/ch-10/ch_10_summary.html" },

  /* ---------- Chapter 11: Relational Databases ---------- */
  { category: "Chapter 11", title: "Summary", file: "/pages/PYTHON/ch-11/ch_11_summary.html" },
  { category: "Chapter 11", title: "Assertion and Reason", file: "/pages/PYTHON/ch-11/ch_11_A_and_R.html" },
  { category: "Chapter 11", title: "Solved Problems", file: "/pages/PYTHON/ch-11/ch_11_Solved_Problems.html" },


  /* ---------- QP ---------- */
  { category: "QP", title: "QP", file: "/pages/PYTHON/QP/halfTearly.html" },
  { category: "QP", title: "QPA1", file: "/pages/PYTHON/QP/halfTearly-Part-A-Section-I.html" },
  { category: "QP", title: "QPA2", file: "/pages/PYTHON/QP/halfTearly-Part-A-Section-II.html" },
  { category: "QP", title: "QPB1", file: "/pages/PYTHON/QP/halfTearly-Part-B-Section-I.html" },
  { category: "QP", title: "QPB2", file: "/pages/PYTHON/QP/halfTearly-Part-B-Section-II.html" },
  { category: "QP", title: "QPB3", file: "/pages/PYTHON/QP/halfTearly-Part-B-Section-III.html" },

  /* ---------- Practice section ---------- */
  { category: "Practice", title: "P1 Comparison Operators", file: "pages/PYTHON/Practice/PythonBasics-1-Equality-&-Comparison.html" },
  { category: "Practice", title: "P2 Comparison & Alignment Explained", file: "pages/PYTHON/Practice/PythonBasics-2.html" },

  /* ---------- Hint section ---------- */
  { category: "Hint", title: "Ch5 Type-C-Hints", file: "pages/PYTHON/Practice/h-Ch-5-Type-C.html" },
];

export default pytopics;
